module.exports = __webpack_public_path__ + "img/not-have-noti.8b85c987.png";